import { HOST_NAMES } from '../../config/types'

export const DEFAULT_STALE_DATA_TIMEOUT = 1000 * 60 * 5 // 5 minutes

export type AppConfig = {
  gameDataServiceUrl: string
  gameDataApiKey: string
  hostName: HOST_NAMES
  playerDataServiceUrl: string
  playerDataApiKey: string
  enableClaimForm: boolean
}
